'use client'

import { useIntl } from 'react-intl'
import { useWatch } from 'react-hook-form'
import { Button, Cell } from '@vinted/web-ui'

import { formatCurrency } from '@marketplace-web/currency/currency-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { OfferFormField } from '../constants'

type Props = {
  isOfferPriceDisplayEnabled?: boolean
  currency: string
  isSubmitting: boolean
  transactionId?: number
}

const OfferSubmitButton = ({
  currency,
  isSubmitting,
  isOfferPriceDisplayEnabled = false,
  transactionId,
}: Props) => {
  const translate = useTranslate('conversation.hero_message.make_offer')
  const { locale } = useIntl()

  const offerValue = useWatch({ name: OfferFormField.Offer, disabled: !isOfferPriceDisplayEnabled })
  const isTransactionLoading = !transactionId

  function renderTitle() {
    if (isOfferPriceDisplayEnabled) {
      return translate('offer_modal.actions.submit_with_price', {
        price: offerValue ? formatCurrency(offerValue, { locale, currency }) : '',
      })
    }

    return translate('offer_modal.actions.submit')
  }

  const handleSubmit = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (isSubmitting) {
      event.preventDefault()
    }
  }

  return (
    <Cell>
      <Button
        disabled={isSubmitting || isTransactionLoading}
        isLoading={isSubmitting}
        type={Button.Type.Submit}
        styling={Button.Styling.Filled}
        testId="offer-submit-button"
        onClick={handleSubmit}
      >
        {renderTitle()}
      </Button>
    </Cell>
  )
}

export default OfferSubmitButton
